import checkDataChannel from './lib/checkDataChannel';
import checkGetUserMedia from './lib/checkGetUserMedia';
import checkRTCPeerConnection from './lib/checkRTCPeerConnection';
import getBrowserInfo from './lib/getBrowserInfo';
import getOSName from './lib/getOSName';

var ArDetect = {
  LocalMediaStream:  null,

  ARVideoProfile120x160: 0,        // 120x160
  ARVideoProfile120x120: 1,        // 120x120
  //180P
  ARVideoProfile180x320: 2,        // 180x320
  ARVideoProfile180x180: 3,        // 180x180
  ARVideoProfile180x240: 4,        // 180x240
  //240P
  ARVideoProfile240x320: 5,        // 240x320
  ARVideoProfile240x240: 6,        // 240x240
  ARVideoProfile240x424: 7,        // 240x424
  //360P
  ARVideoProfile360x640: 8,        // 360x640
  ARVideoProfile360x360: 9,        // 360x360
  ARVideoProfile360x480: 10,       // 360x480
  //480P
  ARVideoProfile480x640: 11,       // 480x640
  ARVideoProfile480x480: 12,       // 480x480
  ARVideoProfile480x848: 13,       // 480x848
  //720P
  ARVideoProfile720x960: 14,       // 720x960
  ARVideoProfile720x1280: 15,      // 720x1280
  //1080P
  ARVideoProfile1080x1920: 16,     // 1080x1920

  ResolutionArray: [
    {
      enum: '120P',
      width: '160',
      height: '120',
    },
    {
      enum: '180P',
      width: '320',
      height: '180',
    },
    {
      enum: '240P',
      width: '320',
      height: '240',
    },
    {
      enum: '360P',
      width: '640',
      height: '360',
    },
    {
      enum: '480P',
      width: '640',
      height: '480',
    },
    {
      enum: '720P',
      width: '1280',
      height: '720',
    },
    {
      enum: '1080P',
      width: '1820',
      height: '1080',
    },
  ],

  GetUserMediaSupport: checkGetUserMedia(),
  DataChannelSupport: checkDataChannel(),
  PeerConnectionSupport: checkRTCPeerConnection(),
  BrowserInfo: getBrowserInfo(),
  OSName: getOSName(),

  async createStream(constraints) {
    let promise = new Promise((resolve, reject) => {
      if (!this.GetUserMediaSupport) reject({name: 'no support getUserMedia'});
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        resolve(stream);
      }).catch(err => {
        reject(err);
      });
    });
    return await promise;
  },

  async checkResolution(resolution) {
    let promise = new Promise((resolve, reject) => {
      if (typeof resolution !== Object && !('width' in resolution) && !('height' in resolution)) return;
      this.createStream({
        video: {
          width: resolution.width,
          height: resolution.height
        },
        audio: false,
      }).then(stream => {
        this.LocalMediaStream = stream;
        let video = document.createElement('video');
        video.srcObject = this.LocalMediaStream;
        video.play();
        video.oncanplay = (e) => {
          if (video.videoWidth === resolution.width && video.videoHeight === resolution.height) {
            resolve('support');
          } else {
            resolve('no-support');
          }
          video.remove();
          this.LocalMediaStream && this.LocalMediaStream.getTracks().forEach(track => {
            track.stop();
          });
        };
      }).catch(err => {
        if (err.name !== 'OverconstrainedError') {
          resolve('no-support');
        }
        reject(err);
      });
    });
    return await promise;
  },

  getLocalAudioVolume() {
    return new Promise((resolve,reject) => {
      this.createStream({
        audio: true,
      }).then(stream => {
        let audioContext = new (window.AudioContext || webkitAudioContext)();
        let sourceNode = stream.otWebkitAudioSource || audioContext.createMediaStreamSource(stream);
        let analyser = audioContext.createAnalyser();
        let timeDomainData = new Uint8Array(analyser.frequencyBinCount);
        sourceNode.connect(analyser);

        this.getAudioLevel = function () {
          if (analyser) {
            analyser.getByteTimeDomainData(timeDomainData);
            for (var e = 0, t = 0; t < timeDomainData.length; t++)
              e = Math.max(e, Math.abs(timeDomainData[t] - 128));
            return parseInt((e / 128)*100)
          }
        }
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },

  getAudioLevel() {
    return 0;
  }
};

export default ArDetect;